const REQUEST_TIMEOUT = 10000;

export { REQUEST_TIMEOUT };
